module.exports = __webpack_public_path__ + "img/katarina_events_19.c1c29b22.jpg";